import { Col, Row } from 'react-bootstrap';
import UpdateProfileForm from '../components/admin/clients/updateProfile/UpdateProfileForm';
import AdminLayout from './layout/AdminLayout';

const UpdateProfile = () => {

    return (
        <AdminLayout >
            <Row>
                <Col>
                    <UpdateProfileForm />
                </Col>
            </Row>
        </AdminLayout>
    )
}

export default UpdateProfile;